import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import ImageBlock from '../ImageBlock/imageBlock.component';

import './collegeCategoryCard.module.css';

const CollegeCategoryCard = props => {

    const { title, image, link } = props;

    return (
        <Link to={link}>
            <Card>
                <ImageBlock
                    width="530"
                    height="280"
                    src={image}
                />
                <Card.Title styleName="college-card-title">{title}</Card.Title>
            </Card>
        </Link>
    )
}

export default CollegeCategoryCard;